// @ts-nocheck
// Product Details deviated so much that the entire file is now different so we're no longer tagging with custom code as custom code is now the entire file.

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setSelectedImageIndex from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/SetSelectedImageIndex";
import { getSelectedImage } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import { TabDefinition } from "@insite/client-framework/Types/TabDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { LazyImageProps, LazyImageStyle } from "@insite/mobius/LazyImage";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { StyledImgWrapper } from "@store/MobiusOverrides/Img/Img";
import useIsMobile from "@store/Framework/Common/Hooks/useIsMobile";
import {
    carouselFieldDefinitions,
    CarouselFieldProps,
    carouselFields,
} from "@store/Framework/Common/Utilities/CarouselWidgetHelpers";
import { getContextualCssUnitField } from "@store/Framework/Common/Utilities/FieldHelpers";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import PrimaryDetailsZoomModal from "@store/Library/Components/Bunzl/ProductDetails/PrimaryDetailsZoomModal";
import ProductDetailsCarouselButtons, {
    defaultProductDetailsCarouselButtonsCss,
} from "@store/Library/Components/Bunzl/ProductDetails/ProductDetailsCarouselButtons";
import PrimaryDetailsPrimaryImageCarousel, {
    defaultDetailsCarouselCss,
} from "@store/Library/Components/Bunzl/ProductDetails/ProductDetailsPrimaryImageCarousel";
import useImageZoom, { UseZoomOptions } from "@store/Library/Components/Bunzl/useImageZoom";
import { ModalPresentationProps } from "@store/MobiusOverrides/Modal/Modal";
import ProductImageCarousel, {
    defaultProductImageCarouselCss,
    ProductImageCarouselStyles,
} from "@store/Overrides/Components/ProductImageCarousel";
import { ProductPrimaryImageStyles } from "@store/Overrides/Components/ProductPrimaryImage";
import BunzlZoomOut from "@store/Overrides/Widgets/ProductDetails/BunzlZoomOut";
import { lazyImageStyles } from "@store/Themes/common/mixins/lazyload";
import useCurrentBreakpointValue from "@toolkit/Framework/Common/Hooks/useCurrentBreakpointValue";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as cssLinter from "css";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

enum ownFields {
    enableZoomContainer = "enableZoomContainer",
    zoomWindowHeight = "zoomWindowHeight",
    zoomWindowWidth = "zoomWindowWidth",
    zoomWindowOffsetTop = "zoomWindowOffsetTop",
    zoomWindowOffsetLeft = "zoomWindowOffsetLeft",
    zoomModalHeight = "zoomModalHeight",
    zoomModalWidth = "zoomModalWidth",
    targetImageSize = "targetImageSize",
    enableZoomModal = "enableZoomModal",
    verticalThumbnails = "verticalThumbnails",
    customCSS = "customCSS",
}

const fields = { ...ownFields, ...carouselFields };

export interface OwnProps extends Props {
    fields: {
        [fields.enableZoomContainer]: boolean;
        [fields.zoomWindowHeight]: number;
        [fields.zoomWindowWidth]: number;
        [fields.zoomModalHeight]: string;
        [fields.zoomModalWidth]: string;
        [fields.zoomWindowOffsetTop]: string;
        [fields.zoomWindowOffsetLeft]: string;
        [fields.targetImageSize]: number;
        [fields.enableZoomModal]: boolean;
        [fields.verticalThumbnails]: boolean;
        [fields.customCSS]: string;
    } & CarouselFieldProps;
}
const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    selectedImage: getSelectedImage(state, ownProps.product),
    selectedImageIndex: state.pages.productDetails.selectedImageIndex,
});

const mapDispatchToProps = {
    setSelectedImageIndex,
};

const mobileQuery = getMediaQuery({ option: "only", first: true, min: 0, max: 500, last: false });
export interface ProductDetailsPrimaryImageStyles {
    /**
     * @deprecated Use primaryImage styles instead.
     */
    centeringWrapper?: InjectableCss;
    hiddenWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    image?: LazyImageProps;

    primaryImage?: ProductPrimaryImageStyles;
    fullPrimaryImageModal?: ModalPresentationProps;
    fullPrimaryImage?: ProductPrimaryImageStyles;
    imageCarousel?: ProductImageCarouselStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeText?: InjectableCss;
    badgeImageProps?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> | undefined;
    badgeImageWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    // Store Custom Code
    zoomButton?: ButtonPresentationProps;
    thumnailCarouselStyles?: ProductImageCarouselStyles;
    containerWrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
}

export const primaryImageStyles: ProductDetailsPrimaryImageStyles = {
    thumnailCarouselStyles: {
        CarouselSlideContainer: {
            css: css`
                gap: ${pxToRem(8)};
            `,
        },
        mainContainer: {
            css: css`
                align-self: center;
                height: 100%;
            `,
        },
        carouselContainer: {
            css: css`
                gap: ${pxToRem(16)};
            `,
        },
        verticalNextArrowGridItem: {
            css: css`
                display: none;
            `,
        },
        verticalPrevArrowGridItem: {
            css: css`
                display: none;
            `,
        },
        carouselWrapper: {
            css: css`
                margin-top: ${pxToRem(4)};
            `,
        },
    },

    zoomButton: {
        variant: "tertiary",
        icon: {
            src: BunzlZoomOut,
            position: "left",
        },
        css: css`
            color: ${getColor("common.link")};
            order: 1;
            position: relative;
            display: flex;
            height: ${pxToRem(48)};
            width: ${pxToRem(48)};
            align-items: center;
            justify-content: center;
            margin-top: -4.75rem;
            border-radius: 50%;
            border: 1px solid ${getColor("common.border")};
            box-shadow: ${({ theme }) => theme.shadows[1]};
            ${IconWrapper} {
                color: ${getColor("common.link")};

                :hover {
                    svg {
                        color: ${getColor("common.linkDark")};
                    }
                }
                width: ${pxToRem(18)};
                height: ${pxToRem(18)};
                top: 0;
                > svg {
                    color: ${getColor("common.link")};
                    height: ${pxToRem(18)};
                    width: ${pxToRem(18)};
                }
                margin: 0;
            }
        `,
    },
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            ${mobileQuery} {
                transform: scale(0.5);
            }
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
        `,
    },
    fullPrimaryImageModal: {
        cssOverrides: {
            modalContainer: css`
                width: auto;
            `,
            modalBody: css`
                width: auto;
                height: auto !important;
            `,
            modalTitle: css`
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
                padding: 0;
                border: 0;
            `,
            modalContent: css`
                padding: 0;
                text-align: center;
            `,
        },
    },

    primaryImage: {
        image: {
            css: css`
                ${lazyImageStyles()};
            `,
        },
        centeringWrapper: {
            css: css`
                height: 100%;
                width: 100%;

                ${StyledImgWrapper} ${LazyImageStyle} {
                    > img {
                        transition: opacity 0.3s ease-in-out;
                        object-fit: contain;
                    }
                }
                ${breakpointValues(["25vh", "100%"], "max-height")};
            `,
        },
    },
    containerWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 100%;
            gap: 1rem;
        `,
    },
    innerWrapper: {
        css: css`
            display: flex;
            flex-direction: row-reverse;
            width: 100%;
            min-height: 50%;
        `,
    },
};

const styles = primaryImageStyles;
const ProductDetailsPrimaryImage: React.FC<OwnProps> = ({
    product,
    selectedImageIndex,
    setSelectedImageIndex,
    fields: {
        enableZoomContainer,
        targetImageSize,
        zoomWindowHeight,
        zoomWindowWidth,
        zoomWindowOffsetLeft,
        zoomWindowOffsetTop,
        verticalThumbnails,
        customCSS,
    },
    fields,
}) => {
    const isMobile = useIsMobile({ width: 1050 });
    const numberOfTotalImages = React.useMemo(
        () => (product?.images?.filter(image => !image.name.toLocaleLowerCase().includes("sizechart")) ?? []).length,
        [product?.images?.length],
    );
    const [isModalOpen, setIsModalOpen] = useState(false);
    enableZoomContainer = enableZoomContainer && !isMobile;
    const containerRef = React.useRef<HTMLDivElement>(null);
    const options: UseZoomOptions = {
        targetImageSize,
        windowHeight: zoomWindowHeight,
        windowWidth: zoomWindowWidth,
        offset: {
            horizontal: zoomWindowOffsetLeft,
            vertical: zoomWindowOffsetTop,
        },
        index: selectedImageIndex,
        fillContainer: true,
    };

    const { isZoomOpen, setIsZoomOpen } = useImageZoom(options, containerRef, "zoomElement");

    const imageClickHandler = (event: React.MouseEvent<HTMLImageElement>) => {
        if (isMobile || !enableZoomContainer) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        setIsZoomOpen(!isZoomOpen);
    };

    const selectImageHandler = React.useCallback(
        (index: number) => {
            setSelectedImageIndex({ index });
        },
        [setSelectedImageIndex],
    );

    if (!product) {
        return null;
    }

    useEffect(() => {
        if (!isZoomOpen || isMobile) {
            return;
        }
        const handleGlobalClick = () => {
            setIsZoomOpen(false);
        };
        document.addEventListener("click", handleGlobalClick);
        return () => {
            document.removeEventListener("click", handleGlobalClick);
        };
    }, [isZoomOpen, setIsZoomOpen, isMobile]);

    const imagesToShowByBreakpoint = useCurrentBreakpointValue([1, 2, 2, 3, 3]) ?? 1;
    const imagesToShow = Math.min(numberOfTotalImages, imagesToShowByBreakpoint);
    const shouldShowCarousel = imagesToShow > 1 && !isMobile && verticalThumbnails;
    const customCssWrapper = {
        css: css`
            ${customCSS}
        `,
    };
    return (
        <StyledWrapper
            {...customCssWrapper}
            data-test-selector="productDetails_primaryImage_customCssWrapper" /* Store Custom Code */
        >
            <StyledWrapper
                {...styles.containerWrapper}
                className="product-details-image-container-wrapper"
                data-test-selector="productDetails_primaryImage_containerWrapper" /* Store Custom Code */
            >
                <StyledWrapper
                    {...styles.innerWrapper}
                    ref={containerRef}
                    className="product-details-image-inner-container-wrapper"
                    data-test-selector="productDetails_primaryImage_innerWrapper" /* Store Custom Code */
                >
                    <PrimaryDetailsPrimaryImageCarousel
                        fields={fields}
                        productDetailsStyles={styles}
                        selectImageHandler={selectImageHandler}
                        selectedImageIndex={selectedImageIndex}
                        isZoomOpen={isZoomOpen}
                        imageClickHandler={imageClickHandler}
                        data-test-selector="productDetails_primaryImage_mainCarousel" /* Store Custom Code */
                    />

                    {shouldShowCarousel && (
                        <ProductImageCarousel
                            selectedIndex={selectedImageIndex}
                            onSelectImage={selectImageHandler}
                            scrollingBehavior="vertical"
                            numberOfVisibleThumbnails={imagesToShow}
                            extendedStyles={styles.thumnailCarouselStyles}
                            data-test-selector="productDetails_primaryImage_thumbnailCarousel" /* Store Custom Code */
                        />
                    )}
                </StyledWrapper>

                <PrimaryDetailsZoomModal
                    fields={fields}
                    isMobile={isMobile ?? false}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    onImageChange={selectImageHandler}
                    productDetailsStyles={styles}
                    selectedImageIndex={selectedImageIndex}
                    data-test-selector="productDetails_primaryImage_zoomModal" /* Store Custom Code */
                />

                {!isMobile && (
                    <ProductDetailsCarouselButtons
                        handleZoomClick={() => setIsModalOpen(true)}
                        selectedImageIndex={selectedImageIndex}
                        setSelectedImageIndex={selectImageHandler}
                        verticalThumbnails={verticalThumbnails}
                        numberOfImagesToShow={imagesToShow}
                        numberOfImages={numberOfTotalImages}
                        data-test-selector="productDetails_primaryImage_carouselButtons" /* Store Custom Code */
                    />
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};
const zoomTab: TabDefinition = {
    displayName: "Image Zoom",
    sortOrder: 3,
};

const defaultCustomCss = `.product-details-image-container-wrapper {
}
.product-details-image-inner-container-wrapper {
}
${defaultDetailsCarouselCss}${defaultProductImageCarouselCss}${defaultProductDetailsCarouselButtonsCss}
`;
const modalHeightField = getContextualCssUnitField(fields.zoomModalHeight);
const modalWidthField = getContextualCssUnitField(fields.zoomModalWidth);
const zoomWindowOffsetTopField = getContextualCssUnitField(fields.zoomWindowOffsetTop);
const zoomWindowOffsetLeftField = getContextualCssUnitField(fields.zoomWindowOffsetLeft);
const widgetModule: WidgetModule<FoundationFieldDefinition> = {
    component: withProduct(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsPrimaryImage)),
    definition: {
        displayName: "Primary Image",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            ...carouselFieldDefinitions,
            {
                name: fields.enableZoomContainer,
                displayName: "Enable Zoom Container",
                fieldType: "General",
                defaultValue: true,
                editorTemplate: "CheckboxField",
                sortOrder: 3,
                tab: zoomTab,
            },
            {
                name: fields.targetImageSize,
                displayName: "Target Image Size",
                fieldType: "Contextual",
                tooltip: "The Width of the zoomed in image",
                defaultValue: 5000,
                editorTemplate: "IntegerField",
                tab: zoomTab,
                isVisible: item => item.fields.enableZoomContainer,
            },
            {
                name: fields.zoomWindowHeight,
                displayName: "Zoom Window Height",
                fieldType: "Contextual",
                tooltip: "The Height of the zoomed in image",
                defaultValue: 0,
                editorTemplate: "IntegerField",
                tab: zoomTab,
                isVisible: item => item.fields.enableZoomContainer,
            },
            {
                name: fields.zoomWindowWidth,
                displayName: "Zoom Window Width",
                fieldType: "Contextual",
                tooltip: "The Width of the zoomed in image",
                defaultValue: 0,
                editorTemplate: "IntegerField",
                tab: zoomTab,
                isVisible: item => item.fields.enableZoomContainer,
            },
            {
                name: fields.zoomModalHeight,
                displayName: "Zoom Image Max Height",
                fieldType: "General",
                tooltip: "Maximum height for the zoom image (e.g., '90vh' or '600px')",
                defaultValue: "90vh",
                editorTemplate: "TextField",
                tab: zoomTab,
                isVisible: item => item.fields.enableZoomContainer,
            },
            {
                displayName: "Zoom Modal Width",
                ...modalWidthField.definition,
                defaultValue: "80vw",
                isVisible: item => item.fields.enableZoomModal,
            },
            {
                displayName: "Zoom Modal Height",
                ...modalHeightField.definition,

                defaultValue: "90vh",
                isVisible: item => item.fields.enableZoomModal,
            },
            {
                name: fields.enableZoomModal,
                displayName: "Enable Zoom Modal",
                fieldType: "Contextual",
                defaultValue: true,
                sortOrder: 3,
                editorTemplate: "CheckboxField",
            },
            {
                displayName: "Zoom Window Offset Top",
                ...zoomWindowOffsetTopField.definition,
                defaultValue: "",
                tab: zoomTab,
                isVisible: item => item.fields.enableZoomContainer,
            },
            {
                displayName: "Zoom Window Offset Left",
                ...zoomWindowOffsetLeftField.definition,
                defaultValue: "",
                tab: zoomTab,
                isVisible: item => item.fields.enableZoomContainer,
            },
            {
                name: fields.verticalThumbnails,
                displayName: "Vertical Thumbnails",
                fieldType: "General",
                defaultValue: false,
                editorTemplate: "CheckboxField",
                instructions: "Display thumbnails vertically",
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: { displayName: "Advanced", sortOrder: 100 },
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (!value) return "";
                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }
                    return "Unable to parse CSS";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
